import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseStepComponent } from '../../base';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'abrir-recurso',
  templateUrl: './abrir-recurso.component.html'
})
export class AbrirRecursoComponent extends BaseStepComponent {

  @Input() recurso: RecursoFiltro;

  @Output() listaAnexoChange = new EventEmitter<any[]>();

  cadastro = this.formBuilder.group({
    justificativa: [null, [Validators.required, Validators.maxLength(4000)]],
  })

  init() {
    if (this.recurso === null) {
      this.recurso = new RecursoFiltro();
    }
    this.cadastro.get('justificativa').setValue(this.recurso.Justificativa);
    this.listaAnexoChange.emit(this.recurso.AnexoRecurso);
    this.cadastro.valueChanges.subscribe(x => {
      this.recurso.Justificativa = x.justificativa;
    });
  }

  selecionaArquivo(event) {
    for (const file of event.files) {
      if (file.name.match(/.pdf/) || file.name.match(/.jpg/) || file.name.match(/.png/)) {
        this.IncluirArquivo(file, this.recurso.AnexoRecurso, this.listaAnexoChange, { tipo: 3 })
      }
    }
  }

  removeElementList(value: any) {
    this.recurso.AnexoRecurso.forEach((item, index) => {
      if (item.nome_arquivo === value.file.name && item.id < 1) {
        super.removeFromList(this.recurso.AnexoRecurso, this.listaAnexoChange, index, 'anexos');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/abrir-recurso/abrir-recurso.component.ts